// Pure leaf so value-importers (e.g. the ProjectChat ingestion hook that
// invalidates this query) get the key WITHOUT dragging in the query hook's
// `placement-store → scribeHTTP → authModel` chain, which trips the
// module-init TDZ in suites that `requireActual('@/features/agent-harness')`.
export const NOTE_PUSH_TARGETS_QUERY_KEY = 'note-push-targets';
